
import {
  TechRadarApi,
} from '@backstage-community/plugin-tech-radar';
import { TechRadarLoaderResponse } from '@backstage-community/plugin-tech-radar-common';

import {quadrants, rings} from "./TechRadar.structure";
import {radarEntriesByGroup} from "./TechRadar.entries";

const entries = Object.values(radarEntriesByGroup)
    .flatMap(entry => entry)

export const content: TechRadarLoaderResponse = {
    entries,
    quadrants,
    rings,
};

export class TechRadarClient implements TechRadarApi {
    // It's also possible to load data from backend
    // https://github.com/backstage/community-plugins/tree/main/workspaces/tech-radar/plugins/tech-radar#how-do-i-load-in-my-own-data
    // But our approach is better(for static data):
    // it's type-safe (errors in TechRadar entries are caught at compile time and visible to PR author),
    // and we wouldn't get advantages of using tech-radar-backend plugin
    async load(_id: string | undefined): Promise<TechRadarLoaderResponse> {
        // if needed id prop can be used to fetch the correct data
        return content;
    }
}
